import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Member, UpdateOwner } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { permissionQueryKeys } from "@/query/permission";
import { memberQueryKeys } from "./keys";


export const useUpdateOwner = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, UpdateOwner>({
        mutationKey: ["member", "owner", "update"],
        mutationFn: async (form: UpdateOwner) => {
            try {
                const { data } = await memberRepository.updateOwner(scenarioId, form);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries({ queryKey: permissionQueryKeys.me(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: memberQueryKeys.all(scenarioId) })
            ]);
        }
    });
};
